import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { Form } from 'antd'

import { AppContext } from '../../context/AppContext'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import { TagDescription } from '../../constants/forms/ProductTags'
import {
    EditProductTag,
    getSingleProductTag,
} from '../../network/ProductTags'

const ProductTagDetails = () => {
    const { token } = useContext(AppContext)
    const [form] = Form.useForm()
    let { tagId } = useParams()

    const tagDetails = useQuery(
        [
            'getSingleProductTag',
            {
                tagId: tagId,
                token: token.token,
            },
        ],
        getSingleProductTag,
        {
            refetchOnWindowFocus: false,
        }
    )

    return (
        <PageWrap
            goBack
            isLoading={tagDetails.isLoading}
            title={tagDetails.data?.name}
        >
            {tagDetails.isError ? (
                <Error retry={() => tagDetails.refetch()} />
            ) : tagDetails.isLoading ? (
                <Loader />
            ) : (
                <FormWrap
                    title="edit_product_tag"
                    request={EditProductTag}
                    onSuccess="/product-tags"
                    onCancel="/product-tags"
                    id={tagId}
                    data={tagDetails.data}
                    invalidate={['getProductTags', 'getSingleProductTag']}
                >
                    <div className="SectionHorizontalWrap">
                        <FormBlock form={form} formTemplate={TagDescription} />
                    </div>
                </FormWrap>
            )}
        </PageWrap>
    )
}

export default ProductTagDetails
